import styled from "styled-components";
import {SpinnerLogoDefaultBox} from "./spinner-logo.default.box";

export const SpinnerLogoHarringtonBox = styled(SpinnerLogoDefaultBox)`
  background-position: -823px -345px;
`;